// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"jE-z","hovered":"kE-z","hoverImage":"lE-z","mainImage":"mE-z","imageNoBackground":"nE-z","fullSizeImage":"oE-z"};